import { useMemo } from 'react';

import { getBundleInfo } from '@ge/feat-manage/util/bundle-util';
import { getFiterTasks } from '@ge/feat-manage/util/tasks-util';

export const useCalendarCardDetails = ({ tasks, date }) => {
  return useMemo(() => {
    if (!tasks?.length) return { bundleInfo: {} };
    let filterTask = getFiterTasks(tasks);

    const bundleInfo = getBundleInfo(filterTask, date);
    const sameAssetTasks = filterTask.length == bundleInfo.sameAssetTaskCount ? true : false;
    const partialCompleted =
      bundleInfo.completedTasks != 0 && filterTask.length !== bundleInfo.completedTasks ? true : false;

    return { bundleInfo, sameAssetTasks, partialCompleted };
  }, [tasks, date]);
};
